<template>
    <div class="product">
        <div style="display: flex; justify-content: space-between; align-items: baseline">
            <PageTitle main="Produtos/Serviços" sub="" />
            <b-button  v-show="!modalActive" id="btn-principal" variant="success" @click="addProduct()" size="lgx" class="mb-2" v-if="user.pro_adi">
                <i class="fa fa-plus"></i> Adicionar
            </b-button>
        </div>

        <div id="pageGrid" v-show="!modalActive">
            <b-table :items="products" :fields="fields"
                responsive 
                striped
                borderless>
                <template slot="nm_produto" slot-scope="data">
                    <span style="font-weight: 500;">{{ data.item.nm_produto }}</span> <br>
                    <span style="font-size: smaller;">{{ data.item.tipo }}</span>
                </template>
                <template slot="nm_empresa" slot-scope="data">
                    <span style="font-weight: 500;">{{ data.item.nm_empresa }}</span> <br>
                    <span style="font-size: smaller;">{{ data.item.cnpj_empresa }}</span>
                </template>
                <template slot="actions" slot-scope="data">
                    <b-button variant="primary" @click="loadProduct(data.item)" size="sm mr-2">  
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button variant="danger" @click="removeProduct(data.item)" size="sm" v-if="user.pro_exc">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <b-pagination class="customPagination mt-4" size="md" v-model.trim="page" :total-rows="count" :per-page="limit" />
        </div>
        
        <b-modal ref="modalRemove" hide-footer hide-header centered title="Confirmação!">
            <p class="my-4" style="text-align: center;">Deseja realmente excluir este produto?</p>
            <template v-slot:modal-footer="{ hideRemove , confirmeRemove }">
                <b-row class="text-center mb-4" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button variant="danger" class="mr-2"
                            @click="confirmeRemove()">Excluir 
                        </b-button>
                        <b-button class="mr-2"
                            @click="hideRemove()">Cancelar
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>       

        <div id="pageEdition" v-show="modalActive">
            <b-card :header="tituloModal"> 
                <b-form @submit.prevent="submit">
                    <div class="title-prod">
                        <p>Dados do Produto/Serviço</p>
                    </div>

                    <input id="usuario_id" type="hidden" v-model.trim="this.$store.state.user.userid"> 
                    
                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Código" label-for="product-produto_id">
                                <b-form-input 
                                    type="text"
                                    id="product-produto_id" 
                                    name="product-produto_id" 
                                    ref="product-produto_id" 
                                    v-model.trim="product.produto_id" 
                                    readonly>
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="10" sm="12">
                            <b-form-group label="*Empresa" label-for="product-empresa_id">
                                <b-form-select 
                                    id="product-empresa_id"
                                    name="product-empresa_id"
                                    ref="product-empresa_id"
                                    :options="companies" v-model.trim="product.empresa_id" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    :class="{ 'form-control is-invalid' : $v.product.empresa_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="*Nome Produto/Serviço" label-for="product-nm_produto">
                                <b-form-input 
                                    type="text" 
                                    id="product-nm_produto" 
                                    name="product-nm_produto"
                                    ref="product-nm_produto"
                                    v-focus
                                    v-model.trim="product.nm_produto" 
                                    :class="{ 'form-control is-invalid' : $v.product.nm_produto.$error }"
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    maxlength="100"
                                    placeholder="Informe o nome do produto">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group label="*Status" label-for="product-fl_status">
                                <b-form-select 
                                    id="product-fl_status"
                                    name="product-fl_status"
                                    ref="product-fl_status"
                                    v-model.trim="product.fl_status" :options="optStatus"
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    :class="{ 'form-control is-invalid' : $v.product.fl_status.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="4" sm="12">
                            <b-form-group label="*Venda" label-for="product-vlr_produto">
                                <input 
                                    type="text" 
                                    id="product-vlr_produto" 
                                    name="product-vlr_produto" 
                                    ref="product-vlr_produto" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    v-model.lazy="product.vlr_produto"
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="5" sm="12">
                            <b-form-group label="*Emitir Nota com Descrição Auxiliar" label-for="product-fl_emite_desc_aux">
                                <b-form-select 
                                    id="product-fl_emite_desc_aux"
                                    name="product-fl_emite_desc_aux"
                                    ref="product-fl_emite_desc_aux"
                                    v-model.trim="product.fl_emite_desc_aux" :options="optSimNao"
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    :class="{ 'form-control is-invalid' : $v.product.fl_emite_desc_aux.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="*Descrição Auxiliar" label-for="product-descricao_servico">
                                <b-form-textarea
                                    type="text"
                                    id="product-descricao_servico" 
                                    name="product-descricao_servico" 
                                    ref="product-descricao_servico" 
                                    v-model.trim="product.descricao_servico" 
                                    rows="3"
                                    max-rows="3"
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))">
                                </b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <hr>
                    <div class="title-prod">
                        <p>Impostos da NFS-e</p>
                    </div>

                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="*Atividade / CNAE" label-for="product-cnae_id">
                                <b-form-select 
                                    id="product-cnae_id"
                                    name="product-cnae_id"
                                    ref="product-cnae_id"
                                    v-model.trim="product.cnae_id" 
                                    :options="cnaesCache"
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    :class="{ 'form-control is-invalid' : $v.product.cnae_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group label="*Cofins" label-for="product-vlr_cofins">
                                 <input 
                                    type="text" 
                                    id="product-vlr_cofins" 
                                    name="product-vlr_cofins" 
                                    ref="product-vlr_cofins" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    v-model.lazy="product.vlr_cofins"
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*CSLL" label-for="product-vlr_csll">
                                 <input 
                                    type="text" 
                                    id="product-vlr_csll" 
                                    name="product-vlr_csll" 
                                    ref="product-vlr_csll" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    v-model.lazy="product.vlr_csll"
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*INSS" label-for="product-vlr_inss">
                                 <input 
                                    type="text" 
                                    id="product-vlr_inss" 
                                    name="product-vlr_inss" 
                                    ref="product-vlr_inss" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    v-model.lazy="product.vlr_inss"
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*IR" label-for="product-vlr_ir">
                                 <input 
                                    type="text" 
                                    id="product-vlr_ir" 
                                    name="product-vlr_ir" 
                                    ref="product-vlr_ir" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    v-model.lazy="product.vlr_ir"
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="*PIS" label-for="product-vlr_pis">
                                 <input 
                                    type="text" 
                                    id="product-vlr_pis" 
                                    name="product-vlr_pis" 
                                    ref="product-vlr_pis" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    v-model.lazy="product.vlr_pis"
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*ISS" label-for="product-vlr_iss">
                                 <input 
                                    type="text" 
                                    id="product-vlr_iss" 
                                    name="product-vlr_iss" 
                                    ref="product-vlr_iss" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    v-model.lazy="product.vlr_iss"
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    v-money="money" />                                 
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*ISS Retido Fonte" label-for="product-fl_iss_retido">
                                <b-form-select 
                                    id="product-fl_iss_retido"
                                    name="product-fl_iss_retido"
                                    ref="product-fl_iss_retido"
                                    v-model.trim="product.fl_iss_retido" :options="optSimNao"
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    :class="{ 'form-control is-invalid' : $v.product.fl_iss_retido.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="5" sm="12">
                            <b-form-group label="*Alíquota aplicável (Simples Nacional ou ISS)" label-for="product-aliquota_iss">
                                 <input 
                                    type="text" 
                                    id="product-aliquota_iss" 
                                    name="product-aliquota_iss" 
                                    ref="product-aliquota_iss" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"       
                                    v-model.lazy="product.aliquota_iss"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>                       
                    </b-row>

                    <b-row>
                        <b-col md="7" sm="12">
                            <b-form-group label="Item da Lista de Serviço (LC116)" label-for="product-lista_servico_id">
                                <b-form-select 
                                    id="product-lista_servico_id"
                                    name="product-lista_servico_id"
                                    ref="product-lista_servico_id"
                                    v-model.trim="product.lista_servico_id" :options="servicesCache"
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    :class="{ 'form-control is-invalid' : $v.product.lista_servico_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="5" sm="12">
                            <b-form-group label="*Cód. de Tributação (Nacional ou Municipal)" label-for="product-cod_servico_municipio">
                                <b-form-input 
                                    type="text"
                                    id="product-cod_servico_municipio" 
                                    name="product-cod_servico_municipio" 
                                    ref="product-cod_servico_municipio" 
                                    v-model.trim="product.cod_servico_municipio" 
                                    :class="{ 'form-control is-invalid' : $v.product.cod_servico_municipio.$error }"
                                    maxlength="9" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    placeholder="Informe o código do serviço">
                                </b-form-input>
                            </b-form-group>
                        </b-col>                        
                    </b-row>

                    <b-row>
                        <!--
                        <b-col md="9" sm="12">
                            <b-form-group label="Descrição do Serviço no Município" label-for="product-desc_servico_municipio">
                                <b-form-input 
                                    type="text"
                                    id="product-desc_servico_municipio" 
                                    name="product-desc_servico_municipio" 
                                    ref="product-desc_servico_municipio" 
                                    v-model.trim="product.desc_servico_municipio" 
                                    :class="{ 'form-control is-invalid' : $v.product.desc_servico_municipio.$error }"
                                    maxlength="600" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    placeholder="Informe a descrição do serviço no município">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        -->
                    </b-row>

                    <!--
                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="Observações do Produto/Serviço" label-for="product-descricao_servico">
                                <b-form-input 
                                    type="text"
                                    id="product-descricao_servico" 
                                    name="product-descricao_servico" 
                                    ref="product-descricao_servico" 
                                    v-model.trim="product.descricao_servico" 
                                    maxlength="100" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.pro_edi))"
                                    placeholder="Campo de outras observações da nota fiscal de serviço. Caso não tenha deixar em branco">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    -->

                    <div style="padding: 10px 0px 10px 0px; display: flex; justify-content: end;"> 
                        <b-button class="mr-2" style="width: 150px;"
                            @click="toggleModal">Cancelar
                        </b-button>
                        <b-button  id="btn-principal" variant="success" v-if="((isInsert) || (user.pro_edi))" class="mr-2" style="width: 150px;"
                            @click="saveProduct">Salvar 
                        </b-button>
                    </div>
                </b-form>        
            </b-card>
        </div>

    </div>  
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import Modal  from '../template/Modal'
import { required } from "vuelidate/lib/validators";
import formMixin from '../../config/mixinform';
import {VMoney} from 'v-money'

// Cache local
import cnaesJson from '../../cache-data/cnaes.json'
import servicesJson from '../../cache-data/listaservicos.json'

export default {
    name: 'Produtos',
    computed: mapState(['user']),
    components: { PageTitle, Modal },
    mixins: [ formMixin ],

    data: function () {
        return {
            mode: 'save',
            modalActive: false,
            tituloModal: null,
            isInsert: false,            

            product: {},
            products: [],
            companies: [],
            
            fields: [
                { key: 'produto_id', label: 'Código' },
                { key: 'nm_produto', label: 'Produto/Serviço' },
                { key: 'nm_empresa', label: 'Empresa' },
                { key: 'status', label: 'Status' },
                { key: 'actions', label: 'Ações', class: 'text-center' }
            ],
            page: 1,
            count: 0,
            limit: 0,

            optSimNao: [
                { value: "S", text: 'Sim' },
                { value: "N", text: 'Não' }
            ],

            optStatus: [
                { value: "A", text: 'Ativo' },
                { value: "I", text: 'Inativo' }
            ],

            cnaesCache: [],

            servicesCache: [],

            money: {
                decimal: ',',
                thousands: '.',	
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false 
            }

        }
    },

    validations: {
        product: {
            nm_produto: { required },
            fl_status: { required },
            empresa_id: { required },
            cnae_id: { required },
            fl_iss_retido: { required },
            lista_servico_id: { required },
            cod_servico_municipio: { required },
            fl_emite_desc_aux: { required }
        }
    },

    directives: {money: VMoney},

    methods: {
        loadProducties() {
            axios.get(`${baseApiUrl}/produto/empsusuario/${this.$store.state.user.empsuser}/pagina/${this.page}`)
                .then(resp => {
                    this.products = resp.data.data.map(item => {
                        const parts = item.nm_empresa.split(" - ", 2);
                        if (parts.length === 2) {
                            const [cnpj_empresa, nm_empresa] = parts;
                            return {...item, cnpj_empresa, nm_empresa };
                        } else {
                            return item;
                        }
                    });
                    this.count = parseInt(resp.data.count)
                    this.limit = parseInt(resp.data.limit)
            })
        },

        loadCompanies() {
            axios.get(`${baseApiUrl}/usuario/empresas/` + this.$store.state.user.userid)  
                 .then(resp => {
                     this.companies = resp.data.data.map(campany => {
                         return { value: campany.empresa_id, text: campany.nm_empresa }
                     })
            })
        },

        loadCnaesCache() {
            let cnaes = cnaesJson.map(cnae => {
                return { value: cnae.cnae_id, text: cnae.nm_cnae }
            })
            this.cnaesCache = cnaes
        },

        loadServicesCache() {
            let services = servicesJson.map(service => {
                return { value: service.lista_servico_id, text: service.nm_servico }
            })
            this.servicesCache = services
        },

        loadProduct(product, mode = 'save') {
            this.mode = mode

            axios.get(`${baseApiUrl}/produto/produto/${product.produto_id}`)
                 .then(resp => {
                     this.product = resp.data.data
            })

            this.tituloModal = 'Editar Produto/Serviço'
            this.toggleModal()
        },

        addProduct() {
            this.product = {}
            this.tituloModal = 'Adicionar Produto/Serviço'
            this.toggleModal()
            this.isInsert = true
        },

        toggleModal() {
            this.modalActive = !this.modalActive;
            if (this.modalActive === false) {
                this.reset()
            }
            this.$v.$reset();            
		},

        reset() {
            this.mode = 'save'
            this.isInsert = false
            this.product = {}
            this.loadProducties()
        },

        focusFirstError() {
            var invalidFields = Object.keys(this.$v.$params).filter(fieldName => this.$v[fieldName].$invalid);
            if (invalidFields) {
                this.$refs.input.$refs.input.focus()
            }
        },

        saveProduct() {
            if (this.validate()) {
                const method = this.product.produto_id ? 'put' : 'post'
                const id = this.product.produto_id ? `/${this.product.produto_id}` : ''
                const url = `${baseApiUrl}/produto${id}`

                axios[method](url, this.product)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)                

                this.toggleModal()
            }
        },
 
        removeProduct(product) {
            this.product = { ...product } 
            this.$refs.modalRemove.show(product);
        },

        hideRemove() { 
            this.$refs.modalRemove.hide();
        },

        confirmeRemove() { 
            this.hideRemove();
            const id = this.product.produto_id

            axios.delete(`${baseApiUrl}/produto/${id}`)
                 .then(() => {
                     this.$toasted.global.defaultSuccess()
                     this.reset()
                 })
                 .catch(showError)
        }
    },

    watch: {
        page() {
            this.loadProducties()
        }
    },

    mounted() {
        this.loadProducties() 
        this.loadCompanies() 
        this.loadCnaesCache()
        this.loadServicesCache()
    }    
}

</script>

<style scoped>
    .title-prod {
        flex: 1;
        display: grid;
    }

    .error {
        border: 3px solid darkred;        
    }

    p {
        font-weight: 600;
        margin-bottom: 10px;
    }

    hr {
        border: 0;
        width: 100%;
        height: 1px;
        margin-top: 15px;
        margin-bottom: 20px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }
</style>

<style>
#app :is(.product, .nfse, .user, .company) td {
    line-height: 1.2;
    vertical-align: middle;
}
</style>